import type {Routes} from '@angular/router';
import {ContactApiService} from '@app/features/request-demo/core/services/contact-api.service';
import {ContactPageFacade} from '@app/features/request-demo/core/services/contact-page.facade';

export const CONTACT_ROUTES: Routes = [
  {
    path: '',
    pathMatch: 'full',
    loadComponent: () =>
      import('./request-demo.component'),
    providers: [
      ContactPageFacade,
      ContactApiService,
    ],
  },
];
